import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";

function Portfolio({ log }: Props) {
  const { t } = useTranslation();

  return (
    <div>
      {log.content.includes("update") ? (
        <p>
          {t(
            `planzoneLogsPage.description.${log.content}.${log.attributes.target}`,
            {
              name: log.attributes.data,
              parent: log.attributes.parent,
            },
          )}
        </p>
      ) : (
        <p>
          {t(`planzoneLogsPage.description.${log.content}`, {
            name: log.attributes.data,
            parent: log.attributes.parent,
          })}
        </p>
      )}
    </div>
  );
}

export { Portfolio };
